import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Media() {
  const navigate = useNavigate();

  // Search input state management
  const [searchQuery, setSearchQuery] = useState('');

  // Modal visibility states for global footer links
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  // Global Media Strategy Database Matrix (All 46 Sourced CDN Assets)
  const mediaCatalog = [
    {
      seriesTitle: "1. Trust, Liability, & Guardrails",
      videos: [
        {
          id: 'trust-part1',
          title: 'How Can I Trust Atlas AI Won\'t Mislead Customers, Give Technical Advice, or Get Me Sued (Part 1)',
          subtitle: 'Operational Guardrails & Safety Parameters',
          url: 'https://atlas-video.b-cdn.net/How%20Can%20I%20Trust%20Atlas%20AI%20Wont%20Mislead%20Customers%20Give%20Technical%20Advice%20or%20Get%20Me%20Sued%201.mp4',
          description: 'A deep-dive look at the hard rails protecting your business. Learn how the system is strictly sandboxed from giving DIY technical troubleshooting or electrical/plumbing advice, focusing 100% on conversion, intake, and dispatch boundaries.'
        },
        {
          id: 'trust-part2',
          title: 'How Can I Trust Atlas AI Won\'t Mislead Customers, Give Technical Advice, or Get Me Sued (Part 2)',
          subtitle: 'Legal Sandbox & Verification Dynamics',
          url: 'https://atlas-video.b-cdn.net/How%20to%20Answer%20Calls%20While%20You\'re%20Working%20on%20Live%20Circuits%20(Without%20Hiring%20Staff)%202.mp4',
          description: 'Analyzing the script structures and intent parsing protocols that prevent misleading statements. See how the agent safely handles complex consumer questions by maintaining brand alignment and pushing for a technician dispatch instead.'
        }
      ]
    },
    {
      seriesTitle: "2. Solo Operator Scale: Live Circuits",
      videos: [
        {
          id: 'circuits-part1',
          title: 'How to Answer Calls While You\'re Working on Live Circuits (Part 1)',
          subtitle: 'Eliminating Distracted Field Intake',
          url: 'https://atlas-video.b-cdn.net/How%20to%20Answer%20Calls%20While%20You\'re%20Working%20on%20Live%20Circuits%20(Without%20Hiring%20Staff)%201.mp4',
          description: 'Working inside a hot panel means you can\'t grab your phone. Discover how solo electrical operators keep their booking pipeline wide open and capture hot inbound dispatches safely without paying for a traditional live answering agency.'
        },
        {
          id: 'circuits-part2',
          title: 'How to Answer Calls While You\'re Working on Live Circuits (Part 2)',
          subtitle: 'Autonomous Customer Onboarding',
          url: 'https://atlas-video.b-cdn.net/How%20to%20Answer%20Calls%20While%20You\'re%20Working%20on%20Live%20Circuits%20(Without%20Hiring%20Staff)%202.mp4',
          description: 'See the exact lifecycle of an inbound service call being greeted, triaged for emergency metrics, and calendar-booked while the founder is actively running multi-wire troubleshooting in the field.'
        }
      ]
    },
    {
      seriesTitle: "3. Solo Operator Scale: Under the Sink",
      videos: [
        {
          id: 'sink-part1',
          title: 'How to Answer Calls While You\'re Under a Sink (Part 1)',
          subtitle: 'Capturing High-Value Inbound Leads',
          url: 'https://atlas-video.b-cdn.net/How%20to%20Answer%20Calls%20While%20You\'re%20Under%20a%20Sink%20(Without%20Hiring%20Staff)%201.mp4',
          description: 'When you are covered in gray water or uncoupling an old garbage disposal, a ringing phone means lost capital. This module covers how to leverage an automated voice agent to hold onto customers while you finish the job at hand.'
        },
        {
          id: 'sink-part2',
          title: 'How to Answer Calls While You\'re Under a Sink (Part 2)',
          subtitle: 'Frictionless Booking Frameworks',
          url: 'https://atlas-video.b-cdn.net/How%20to%20Answer%20Calls%20While%20You\'re%20Under%20a%20Sink%20(Without%20Hiring%20Staff)%202.mp4',
          description: 'An operational breakdown showing how calls are dynamically routed to specific residential plumbing booking tiers, locking in service call fees and logging dispatch coordinates instantly.'
        }
      ]
    },
    {
      seriesTitle: "4. 10-Minute CRM Integrations",
      videos: [
        {
          id: 'crm-int-1',
          title: 'How Atlas AI Integrates with Your Existing CRM in 10 Minutes (Part 1)',
          subtitle: 'Frictionless Field CRM Synchronization',
          url: 'https://atlas-video.b-cdn.net/How%20Atlas%20AI%20Integrates%20with%20Your%20Existing%20CRM%20in%2010%20Minutes%201%20%20_%20includes%20see%20more%20in%20the%20description%20below.mp4',
          description: 'Stop fearing complex IT overhauls. This guide proves how Atlas AI plugs securely into major field management systems within 10 minutes, generating live authentication handshakes without system downtime.'
        },
        {
          id: 'crm-int-2',
          title: 'How Atlas AI Integrates with Your Existing CRM in 10 Minutes (Part 2)',
          subtitle: 'Live Custom Data Mapping',
          url: 'https://atlas-video.b-cdn.net/How%20Atlas%20AI%20Integrates%20with%20Your%20Existing%20CRM%20in%2010%20Minutes%202.mp4',
          description: 'Watch incoming phone transcripts transform instantly into structured job files. Learn how custom tags, dispatch records, and customer history maps map precisely into your calendar framework.'
        }
      ]
    },
    {
      seriesTitle: "5. The 5-Year Business Vision Plan",
      videos: [
        {
          id: '5yr-p1',
          title: 'How To Get The Business You Dreamed Of: 5 Year Plan (Part 1)',
          subtitle: 'Breaking the Technician Trap',
          url: 'https://atlas-video.b-cdn.net/How%20To%20Get%20The%20Business%20You%20Dreamed%20Of%205%20Year%20Plan%20With%20Atlas%20AI%201.mp4',
          description: 'Unlocking true freedom for trade business owners. Part 1 defines the operational blueprint to shift from a stressed tools-on-the-belt operator to a true business asset architect by automating core front-office communications.'
        },
        {
          id: '5yr-p2',
          title: 'How To Get The Business You Dreamed Of: 5 Year Plan (Part 2)',
          subtitle: 'The Economics of Infinite Availability',
          url: 'https://atlas-video.b-cdn.net/How%20To%20Get%20The%20Business%20You%20Dreamed%20Of%205%20Year%20Plan%20With%20Atlas%20AI%202.mp4',
          description: 'Analyzing the multi-year scale matrix. See how eliminating 100% of outbound leakage over 12-24 months builds an unstoppable capital reserve, allowing you to hire tier-1 field crews with ease.'
        },
        {
          id: '5yr-p3',
          title: 'How To Get The Business You Dreamed Of: 5 Year Plan (Part 3)',
          subtitle: 'Systemizing Dispatch Scaling',
          url: 'https://atlas-video.b-cdn.net/How%20To%20Get%20The%20Business%20You%20Dreamed%20Of%205%20Year%20Plan%20With%20Atlas%20AI%203.mp4',
          description: 'This phase demonstrates structuring regional fleet routing blocks. See how automated systems effortlessly process hundreds of booking variables per day across multi-county markets without adding overhead costs.'
        },
        {
          id: '5yr-p4',
          title: 'How To Get The Business You Dreamed Of: 5 Year Plan (Part 4)',
          subtitle: 'Valuation and Corporate Optimization',
          url: 'https://atlas-video.b-cdn.net/How%20To%20Get%20The%20Business%20You%20Dreamed%20Of%205%20Year%20Plan%20With%20Atlas%20AI%204.mp4',
          description: 'What makes a trade enterprise sellable for top dollar? Discover how private equity firms evaluate software-backed scheduling infrastructure vs traditional, easily broken human admin desks.'
        },
        {
          id: '5yr-p5',
          title: 'How To Get The Business You Dreamed Of: 5 Year Plan (Part 5)',
          subtitle: 'Market Area Domination Mechanics',
          url: 'https://atlas-video.b-cdn.net/How%20To%20Get%20The%20Business%20You%20Dreamed%20Of%205%20Year%20Plan%20With%20Atlas%20AI%205.mp4',
          description: 'Unlocking market capture strategies. Learn how instant response execution chokes local marketing channels, aggressively swallowing competitor customer bases simply by out-responding them.'
        },
        {
          id: '5yr-p6',
          title: 'How To Get The Business You Dreamed Of: 5 Year Plan (Part 6)',
          subtitle: 'The Legacy Operations Playbook',
          url: 'https://atlas-video.b-cdn.net/How%20To%20Get%20The%20Business%20You%20Dreamed%20Of%205%20Year%20Plan%20With%20Atlas%20AI%206.mp4',
          description: 'The closing vision roadmap review. Discover how to fully pull your presence out of active day-to-day work tasks while keeping your trade business operating smoothly around the clock.'
        },
        {
          id: '5yr-p7',
          title: 'How To Get The Business You Dreamed Of: 5 Year Plan (Part 7)',
          subtitle: 'The Complete Automation Checkmate',
          url: 'https://atlas-video.b-cdn.net/How%20To%20Get%20The%20Business%20You%20Dreamed%20Of%205%20Year%20Plan%20With%20Atlas%20A%207.mp4',
          description: 'The final masterclass conclusion. Put all the strategic pillars together to achieve total freedom, permanent industry authority, and a hands-free enterprise that runs seamlessly on automated logic.'
        }
      ]
    },
    {
      seriesTitle: "6. Service Pro Requirement Architecture",
      videos: [
        {
          id: 'svc-req-1',
          title: 'How To Meet ALL Your Service Pro Requirements (Part 1)',
          subtitle: 'Compliance, Standards & Verification Profiles',
          url: 'https://atlas-video.b-cdn.net/How%20To%20Meet%20ALL%20Your%20Service%20Pro%20Requirements%20With%20Atlas%20AI%201.mp4',
          description: 'A structural overview detailing how Atlas AI matches modern vendor networks and local service compliance filters. Learn how call processing scripts are tailored to hit tough institutional targets.'
        },
        {
          id: 'svc-req-2',
          title: 'How To Meet ALL Your Service Pro Requirements (Part 2)',
          subtitle: 'Automating Field Quality Assurance',
          url: 'https://atlas-video.b-cdn.net/How%20To%20Meet%20ALL%20Your%20Service%20Pro%20Requirements%20With%20Atlas%20AI%202.mp4',
          description: 'Maintaining your status across corporate broker contracts. See how automated voice verification captures warranty variables, claim IDs, and service authorizations without internal staff oversight.'
        }
      ]
    },
    {
      seriesTitle: "7. Advanced Business Customization",
      videos: [
        {
          id: 'cust-1',
          title: 'How You Can Customize Atlas AI for Your Business (Part 1)',
          subtitle: 'Bespoke Trade Voice Engineering',
          url: 'https://atlas-video.b-cdn.net/How%20You%20Can%20Customize%20Atlas%20AI%20for%20Your%20Business%201.mp4',
          description: 'Your trade brand isn\'t generic, your AI shouldn\'t be either. See how to customize answering scripts, map hyper-local pricing policies, and inject specific company policies into the platform.'
        },
        {
          id: 'cust-2',
          title: 'How You Can Customize Atlas AI for Your Business (Part 2)',
          subtitle: 'Dynamic Rule Configurations',
          url: 'https://atlas-video.b-cdn.net/How%20You%20Can%20Customize%20Atlas%20AI%20for%20Your%20Business%202.mp4',
          description: 'Configure real-time dispatch logic blocks based on field team locations, after-hours rates, and changing seasonal service scopes to perfectly align with your fluid logistics goals.'
        }
      ]
    },
    {
      seriesTitle: "8. Lead Qualification 101 Masterclass",
      videos: [
        {
          id: 'lq-101-p1',
          title: 'Lead Qualification 101: Triage Before Booking (Part 1)',
          subtitle: 'Filtering the Noise from Profit',
          url: 'https://atlas-video.b-cdn.net/Lead%20Qualification%20101%20How%20Atlas%20AI%20Qualifies%20Every%20Caller%20Before%20Booking%201.mp4',
          description: 'Stop burning expensive truck fuel on useless calls. Part 1 demonstrates the conversational logic blocks that separate cold, long-tail information seekers from hot emergency service appointments.'
        },
        {
          id: 'lq-101-p2',
          title: 'Lead Qualification 101: Triage Before Booking (Part 2)',
          subtitle: 'Extracting Job Variables Autonomously',
          url: 'https://atlas-video.b-cdn.net/Lead%20Qualification%20101%20How%20Atlas%20AI%20Qualifies%20Every%20Caller%20Before%20Booking%202.mp4',
          description: 'Watch the agent extract project parameters over the phone—confirming main break coordinates, hazard layouts, and asset details to guarantee field technician compatibility.'
        },
        {
          id: 'lq-101-p3',
          title: 'Lead Qualification 101: Triage Before Booking (Part 3)',
          subtitle: 'Credit Verification & Authority Matching',
          url: 'https://atlas-video.b-cdn.net/Lead%20Qualification%20101%20How%20Atlas%20AI%20Qualifies%20Every%20Caller%20Before%20Booking%203.mp4',
          description: 'Are you talking to a renter or the property owner? This system demo highlights the natural verification patterns used to confirm billing authority before dispatching a professional.'
        },
        {
          id: 'lq-101-p4',
          title: 'Lead Qualification 101: Triage Before Booking (Part 4)',
          subtitle: 'Handling Non-Emergency Estimates',
          url: 'https://atlas-video.b-cdn.net/Lead%20Qualification%20101%20How%20Atlas%20AI%20Qualifies%20Every%20Caller%20Before%20Booking%204.mp4',
          description: 'Don\'t let cheap estimate hunters clog premium dispatch slots. See how the platform moves non-urgent price requests over to low-friction text queues, protecting your prime calendar windows.'
        },
        {
          id: 'lq-101-p5',
          title: 'Lead Qualification 101: Triage Before Booking (Part 5)',
          subtitle: 'The Perfect Intake Checklist',
          url: 'https://atlas-video.b-cdn.net/Lead%20Qualification%20101%20How%20Atlas%20AI%20Qualifies%20Every%20Caller%20Before%20Booking%205.mp4',
          description: 'Review the complete structured data output. Learn how to transform incoming data into clear, actionable job profiles that empower your crews to close jobs on the first visit.'
        }
      ]
    },
    {
      seriesTitle: "9. 24/7 Trade Emergency Responses",
      videos: [
        {
          id: 'emergency-plumbing',
          title: 'For Flooding Plumbing Emergencies: Atlas AI Is There 24/7',
          subtitle: 'High-Urgency Water Triage',
          url: 'https://atlas-video.b-cdn.net/For%20Flooding%20Plumbing%20Emergencies%20Atlas%20AI%20Is%20There%2024_7.mp4',
          description: 'A deep dive into how Atlas AI instantly captures high-ticket burst pipes, failed water heaters, and structural flooding events. See how our localized context layer qualifies the emergency and prevents the customer from hanging up to call another contractor.'
        },
        {
          id: 'emergency-electrical',
          title: 'For Lights Out Electrical Emergencies: Atlas AI Is There 24/7',
          subtitle: 'Critical Power Outage Routing',
          url: 'https://atlas-video.b-cdn.net/For%20Lights%20Out%20Electrical%20%20Emegencies%20Atlas%20AI%20Is%20There%2024_7.mp4',
          description: 'Analyzing live emergency workflows for hazardous electrical failures, blown panels, and total blackouts. Learn how automated conversational triage isolates immediate high-value service requests from long-tail commercial estimates in real time.'
        }
      ]
    },
    {
      seriesTitle: "10. Atlas AI Demo for Electricians",
      videos: [
        {
          id: 'elec-demo-1',
          title: 'How AI Answering Services Work (Part 1)',
          subtitle: 'The Inbound Routing Framework',
          url: 'https://atlas-video.b-cdn.net/How%20AI%20Answering%20Services%20Work_%20Atlas%20AI%20Demo%20for%20%20Electricians%201.mp4',
          description: 'An introductory operational look at how incoming calls to an electrical service company are intercepted by conversational AI. Discover the mechanics behind real-time natural language processing without annoying robot menus or lag.'
        },
        {
          id: 'elec-demo-2',
          title: 'How AI Answering Services Work (Part 2)',
          subtitle: 'Scoping the Scope of Work',
          url: 'https://atlas-video.b-cdn.net/How%20AI%20Answering%20Services%20Work_%20Atlas%20AI%20Demo%20for%20%20Electricians%202.mp4',
          description: 'Watch the system gather critical job criteria—distinguishing between minor fixture updates, EV charger installations, and multi-wire troubleshooting requests to properly prepare field technicians before they roll.'
        },
        {
          id: 'elec-demo-3',
          title: 'How AI Answering Services Work (Part 3)',
          subtitle: 'Dynamic Schedule Matching',
          url: 'https://atlas-video.b-cdn.net/How%20AI%20Answering%20Services%20Work_%20Atlas%20AI%20Demo%20for%20%20Electricians%203.mp4',
          description: 'See the AI cross-reference live technician availability matrices. Learn how it books the high-margin residential repair calls directly into open calendar blocks while preserving designated emergency windows.'
        },
        {
          id: 'elec-demo-4',
          title: 'How AI Answering Services Work (Part 4)',
          subtitle: 'The Instant CRM Integration',
          url: 'https://atlas-video.b-cdn.net/How%20AI%20Answering%20Services%20Work_%20Atlas%20AI%20Demo%20for%20Electricians%20%204.mp4',
          description: 'The closing loop breakdown. See how the entire conversation transcript, parsed job notes, customer history, and confirmed booking time are synced straight to your dispatch board cleanly and instantly.'
        }
      ]
    },
    {
      seriesTitle: "11. Winning in Emergencies Series",
      videos: [
        {
          id: 'customer-win-1',
          title: 'How Atlas AI Always Lets Your Customers Win (Part 1)',
          subtitle: 'Anxiety Defusal Systems',
          url: 'https://atlas-video.b-cdn.net/How%20Atlas%20AI%20Always%20Lets%20Your%20Customers%20Win%20Even%20In%20Emergencies%201.mp4',
          description: 'When home infrastructure fails, customers panic. This module demonstrates the conversational framework used to validate customer stress, confirm immediate help is active, and establish immediate brand authority over the phone.'
        },
        {
          id: 'customer-win-2',
          title: 'How Atlas AI Always Lets Your Customers Win (Part 2)',
          subtitle: 'The Frictionless Booking Loop',
          url: 'https://atlas-video.b-cdn.net/How%20Atlas%20AI%20Always%20Lets%20Your%20Customers%20Win%20Even%20In%20Emergencies%202.mp4',
          description: 'A structural overview of removing logistical hurdles during a midnight panic call. Discover how the system confirms dispatch addresses, captures gate codes, and logs tenant info without putting them on hold.'
        }
      ]
    },
    {
      seriesTitle: "12. Calming Customers with Price Quotes",
      videos: [
        {
          id: 'price-quotes-1',
          title: 'How Atlas AI Calms Your Customers With Price Quotes (Part 1)',
          subtitle: 'Transparent Pricing Frameworks',
          url: 'https://atlas-video.b-cdn.net/How%20Atlas%20AI%20Calms%20Your%20Customers%20With%20Price%20Quotes%201.mp4',
          description: 'Price resistance kills bookings before they start. Watch how Atlas AI dynamically communicates dispatch fees and standard pricing menus transparently, filtering out tire-kickers while booking qualified jobs.'
        },
        {
          id: 'price-quotes-2',
          title: 'How Atlas AI Calms Your Customers With Price Quotes (Part 2)',
          subtitle: 'Handling Price Objections Autonomously',
          url: 'https://atlas-video.b-cdn.net/How%20Atlas%20AI%20Calms%20Your%20Customers%20With%20Price%20Quotes%202.mp4',
          description: 'Learn how the conversational layer navigates common customer financial hesitation. By presenting clear value propositions and booking choices, it protects your margins while converting caller interest.'
        }
      ]
    },
    {
      seriesTitle: "13. From Missed Call to Booked Job",
      videos: [
        {
          id: 'lifecycle-part1',
          title: 'From Missed Call to Booked Job (Part 1)',
          subtitle: 'The Inbound Capture Friction',
          url: 'https://atlas-video.b-cdn.net/From%20Missed%20Call%20to%20Booked%20Job%201.mp4',
          description: 'Dissecting the exact moment a lead goes cold. This module maps out the precise operational loop where traditional office voicemail channels leak revenue and showcases how rapid AI intervention hooks the lead within 60 seconds.'
        },
        {
          id: 'lifecycle-part2',
          title: 'From Missed Call to Booked Job (Part 2)',
          subtitle: 'Automated CRM Dispatch Injection',
          url: 'https://atlas-video.b-cdn.net/From%20Missed%20Call%20to%20Booked%20Job%202.mp4',
          description: 'Watch the closing framework in action. See how qualified lead variables are automatically packaged, scheduled, and injected directly into your field management platforms without manual data entry from a dispatcher.'
        }
      ]
    },
    {
      seriesTitle: "14. After Hours Emergency Calls Series",
      videos: [
        {
          id: 'ah-part1',
          title: 'Are You Leaving Money on the Table? (Part 1)',
          subtitle: 'The Midnight Leak Analysis',
          url: 'https://atlas-video.b-cdn.net/After_Hours%20Emergency%20Calls%20Are%20You%20Leaving%20Money%20on%20the%20Table%201.mp4',
          description: 'An extensive breakdown of the thousands in high-value dispatch revenue lost every single month from emergency plumbing and electrical calls hitting dead-end office voicemail systems between 8 PM and 6 AM.'
        },
        {
          id: 'ah-part2',
          title: 'Are You Leaving Money on the Table? (Part 2)',
          subtitle: 'The Response Time Race',
          url: 'https://atlas-video.b-cdn.net/After_Hours%20Emergency%20Calls%20Are%20You%20Leaving%20Money%20on%20the%20Table%202.mp4',
          description: 'Analyzing why trade consumers select the competitor who answers first, not who has the best ranking. Learn how immediate AI voice triage captures hot leads before they hang up and dial the next local listing.'
        },
        {
          id: 'ah-part3',
          title: 'Are You Leaving Money on the Table? (Part 3)',
          subtitle: 'Live Emergency Handling Simulation',
          url: 'https://atlas-video.b-cdn.net/After_Hours%20Emergency%20Calls%20Are%20You%20Leaving%20Money%20on%20the%20Table%203.mp4',
          description: 'Listen to a structural demonstration of the Atlas AI framework routing a high-urgency burst pipe event at 3:14 AM—safely evaluating location data, confirming job metrics, and initiating a fleet dispatch request.'
        },
        {
          id: 'ah-part4',
          title: 'Are You Leaving Money on the Table? (Part 4)',
          subtitle: 'The Freedom Framework Blueprint',
          url: 'https://atlas-video.b-cdn.net/After_Hours%20Emergency%20Calls%20Are%20You%20Leaving%20Money%20on%20the%20Table%204.mp4',
          description: 'The final overview operational playbook. Discover how trade business founders can decouple from constantly monitoring their mobile dispatch devices overnight while keeping their local service pipeline open.'
        }
      ]
    },
    {
      seriesTitle: "15. 3 Follow-Up Mistakes Series",
      videos: [
        {
          id: 'mistakes-part1',
          title: '3 Mistakes Contractors Make (Part 1)',
          subtitle: 'Inbound Capture Barriers',
          url: 'https://atlas-video.b-cdn.net/3%20Mistakes%20Contractors%20Make%20When%20Following%20Up%20on%20Leads%20and%20How%20Atlas%20AI%20Can%20Help%201.mp4',
          description: 'Discover the critical structural gaps inside traditional office answering models. This module highlights how automated 60-second inbound capture systems isolate emergency booking options from long-tail routine estimates instantly.'
        },
        {
          id: 'mistakes-part2',
          title: '3 Mistakes Contractors Make (Part 2)',
          subtitle: 'Conversion Leak Analysis',
          url: 'https://atlas-video.b-cdn.net/3%20Mistakes%20Contractors%20Make%20When%20Following%20Up%20on%20Leads%20and%20How%20Atlas%20AI%20Can%20Help%202.mp4',
          description: 'Deep dive into standard multi-hour response delays. Learn why delaying communication drop-offs drops contractor lead conversion rates by over 70% and how immediate text back-channels capture active requests.'
        },
        {
          id: 'mistakes-part3',
          title: '3 Mistakes Contractors Make (Part 3)',
          subtitle: 'Systems Engineering Workflow',
          url: 'https://atlas-video.b-cdn.net/3%20Mistakes%20Contractors%20Make%20When%20Following%20Up%20on%20Leads%20and%20How%20Atlas%20AI%20Can%20Help%203.mp4',
          description: 'Actionable deployment matrix. See how Atlas AI plugs directly into field management software tools to create bulletproof dispatch loops without forcing structural layout alterations to your operations.'
        }
      ]
    },
    {
      seriesTitle: "16. Automated Call Architecture & Operations",
      videos: [
        {
          id: 'instant-handling-exp',
          title: 'Atlas AI Instant Call Handling Experience',
          subtitle: 'Live Conversational Latency & Flow',
          url: 'https://atlas-video.b-cdn.net/Atlas_AI_Instant_Call_Handling_Experienc.mp4',
          description: 'A raw look at the speed of the voice processing engine. This module demonstrates how the system answers calls with zero robotic lag, processes complex customer speech intervals naturally, and maintains a seamless conversational flow that keeps callers engaged without hanging up.'
        },
        {
          id: 'emergency-prioritization',
          title: 'How Are Emergencies Prioritized With Atlas AI For Service Pros',
          subtitle: 'High-Urgency Field Triage Logic',
          url: 'https://atlas-video.b-cdn.net/How%20Are%20Emergencies%20Prioritized%20With%20Atlas%20AI%20For%20Service%20Pros.mp4',
          description: 'An operational dive into the triage logic rules. See how the platform automatically detects high-severity keywords like flooding, gas leaks, or loss of power, instantly isolates them from routine inquiries, and executes high-priority routing behaviors to secure the dispatch.'
        },
        {
          id: 'tech-vs-receptionist',
          title: 'How Does Atlas AI Handle Technical Calls Versus A Receptionist',
          subtitle: 'Navigating Trade Jargon and Scope',
          url: 'https://atlas-video.b-cdn.net/How%20Does%20Atlas%20AI%20Handle%20Technical%20Calls%20Versus%20A%20Receptionist.mp4',
          description: 'A direct performance comparison analyzing script boundaries. While traditional answering desk staff frequently struggle with trade jargon or accidentally approve risky technical advice, discover how Atlas AI holds a rigid operational sandbox—safely parsing complex trade terminology while firmly steering the call to a booked dispatch.'
        }
      ]
    }
  ];

  // Dynamically load the top premium module on component initialization
  const [activeVideo, setActiveVideo] = useState(mediaCatalog[0].videos[0]);

  // Pure compute logic to handle the instant playlist sorting framework
  const filteredCatalog = mediaCatalog
    .map((group) => {
      const matchingVideos = group.videos.filter((video) => {
        const query = searchQuery.toLowerCase();
        return (
          video.title.toLowerCase().includes(query) ||
          video.subtitle.toLowerCase().includes(query) ||
          video.description.toLowerCase().includes(query)
        );
      });
      return { ...group, videos: matchingVideos };
    })
    .filter((group) => group.videos.length > 0);

  // Total matching records counter
  const totalMatchesCount = filteredCatalog.reduce((acc, curr) => acc + curr.videos.length, 0);

  return (
    <div className="bg-[#030712] min-h-screen text-white font-sans antialiased flex flex-col justify-between selection:bg-[#a855f7]/30">
      
      {/* GLOBAL NAVIGATION HEADER */}
      <nav className="border-b border-gray-900/80 bg-[#030712]/80 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          
          <div onClick={() => navigate('/')} className="flex items-center gap-2.5 cursor-pointer select-none group">
            <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-[#c026d3] to-[#a855f7] flex items-center justify-center shadow-lg shadow-purple-500/20 group-hover:scale-105 transition-transform">
              <span className="text-white text-lg font-bold">⚡</span>
            </div>
            <span className="text-xl font-extrabold tracking-tight text-white">
              Atlas <span className="text-[#a855f7]">AI</span>
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8 text-sm font-semibold text-gray-400">
            <button onClick={() => navigate('/')} className="hover:text-white transition-colors">Home</button>
            <button onClick={() => navigate('/features')} className="hover:text-white transition-colors">Features</button>
            <button onClick={() => navigate('/calculator')} className="hover:text-white transition-colors">Calculator</button>
            <button onClick={() => navigate('/media')} className="text-white border-b-2 border-[#a855f7] pb-1 cursor-default">Media</button>
            <button onClick={() => navigate('/contact')} className="hover:text-white transition-colors">Contact</button>
          </div>
        </div>
      </nav>

      {/* CORE WORKSPACE CONTENT AREA */}
      <main className="flex-grow max-w-7xl mx-auto px-6 py-24 w-full space-y-12">
        
        {/* INTERACTIVE ROW BLOCK: HEADERS & SEARCH INTEGRATION */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 border-b border-gray-900/50 pb-8">
          <div className="max-w-xl space-y-4 text-left">
            <span className="text-xs font-bold font-mono tracking-widest uppercase text-[#a855f7]">
              Systems Insights & Masterclasses
            </span>
            <h1 className="text-4xl md:text-6xl font-black tracking-tight text-white leading-none">
              Media Hub
            </h1>
            <p className="text-gray-400 text-sm md:text-base leading-relaxed">
              Watch how automated systems optimize communication lines, recover lost booking revenue, and eliminate dispatch bottlenecks for trade businesses.
            </p>
          </div>

          {/* RIGHT JUSTIFIED PREMIUM SEARCH COMPONENT */}
          <div className="w-full md:w-80 space-y-2 text-left md:text-right">
            <label className="text-[10px] uppercase font-mono tracking-widest text-gray-500 block">
              Search Modules Library
            </label>
            <div className="relative">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Filter by keyword, feature, tool..."
                className="w-full h-11 pl-4 pr-10 bg-[#070d19]/50 border border-gray-800 rounded-xl text-sm text-white placeholder-gray-600 outline-none focus:border-[#a855f7] transition-colors"
              />
              <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none text-xs">🔍</span>
            </div>
          </div>
        </div>

        {/* CONTROLLER SECTION: MAIN CINEMATIC MULTIMEDIA VIEWPORTS */}
        {totalMatchesCount > 0 ? (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            
            {/* CINEMATIC VIEW SCREEN COUPLING */}
            <div className="lg:col-span-7 space-y-5 text-left bg-[#070d19]/20 border border-gray-900 rounded-2xl p-4 sm:p-6 shadow-2xl">
              <div className="relative aspect-video w-full bg-[#020613] rounded-xl border border-gray-900 overflow-hidden shadow-inner">
                <video
                  key={activeVideo.id}
                  src={activeVideo.url}
                  controls
                  autoPlay
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="space-y-2 pt-2">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-[10px] uppercase font-mono font-bold px-2 py-0.5 rounded-md bg-purple-950/60 text-purple-400 border border-purple-900/40">
                    Live Session File
                  </span>
                  <span className="text-xs text-gray-500 font-semibold">
                    {activeVideo.subtitle}
                  </span>
                </div>
                <h2 className="text-xl sm:text-2xl font-extrabold tracking-tight text-white">
                  {activeVideo.title}
                </h2>
                <p className="text-gray-400 text-xs sm:text-sm leading-relaxed max-w-3xl">
                  {activeVideo.description}
                </p>
              </div>
            </div>

            {/* SYNCED PLAYLIST SIDE PANEL MATRIX */}
            <div className="lg:col-span-5 h-[650px] overflow-y-auto border border-gray-900 bg-[#070d19]/10 rounded-2xl p-4 space-y-6 scrollbar-thin scrollbar-thumb-gray-900">
              {filteredCatalog.map((group, idx) => (
                <div key={idx} className="space-y-2 text-left">
                  <h3 className="text-xs font-bold uppercase tracking-wider text-gray-500 px-2">
                    {group.seriesTitle}
                  </h3>
                  <div className="space-y-1.5">
                    {group.videos.map((video) => {
                      const isSelected = activeVideo.id === video.id;
                      return (
                        <div
                          key={video.id}
                          onClick={() => setActiveVideo(video)}
                          className={`p-3.5 rounded-xl border transition-all cursor-pointer text-left ${
                            isSelected
                              ? 'bg-[#a855f7]/10 border-[#a855f7]/40 shadow-md shadow-purple-950/20'
                              : 'bg-[#070d19]/40 border-gray-900/60 hover:bg-[#070d19]/80 hover:border-gray-800'
                          }`}
                        >
                          <div className="flex items-start gap-3">
                            <div className={`mt-0.5 w-5 h-5 rounded-md flex items-center justify-center text-[10px] shrink-0 font-bold ${
                              isSelected ? 'bg-[#a855f7] text-white' : 'bg-gray-900 text-gray-500'
                            }`}>
                              {isSelected ? '▶' : '🗂️'}
                            </div>
                            <div className="space-y-0.5">
                              <h4 className={`text-xs font-bold leading-tight transition-colors ${
                                isSelected ? 'text-white' : 'text-gray-300'
                              }`}>
                                {video.title}
                              </h4>
                              <p className="text-[10px] text-gray-500 font-medium tracking-normal line-clamp-1">
                                {video.subtitle}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>

          </div>
        ) : (
          /* EMPTY FALLBACK QUERY STATE SCREEN */
          <div className="border border-dashed border-gray-900 rounded-2xl py-24 text-center max-w-xl mx-auto space-y-4">
            <span className="text-3xl block">🔍</span>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider">No matching assets found</h3>
            <p className="text-xs text-gray-500 max-w-xs mx-auto">
              We couldn't locate any modules matches for "{searchQuery}". Try refining your key phrase search tags.
            </p>
            <button
              onClick={() => setSearchQuery('')}
              className="px-4 py-1.5 bg-gray-900 hover:bg-gray-800 text-xs font-bold rounded-lg transition-colors"
            >
              Clear Current Filter
            </button>
          </div>
        )}
      </main>

      {/* GLOBAL MACRO SYSTEM FOOTER */}
      <footer className="border-t border-gray-900/60 bg-[#030712] pt-16 pb-8 w-full">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-5 gap-10 text-left items-start mb-12">
          
          {/* BRAND MATRICES PROFILE BOX */}
          <div className="col-span-2 space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-purple-600 to-pink-500 flex items-center justify-center text-xs font-bold">
                ⚡
              </div>
              <span className="text-lg font-black tracking-tight text-white">
                Atlas <span className="text-purple-500">AI</span>
              </span>
            </div>
            <p className="text-xs text-gray-500 max-w-xs leading-relaxed font-medium">
              Autonomous conversational architecture custom engineered to secure qualified lead dispatches for enterprise service contractors 24 hours a day.
            </p>
          </div>

          {/* DYNAMIC PRODUCT LISTING COLUMN WITH DEMO DELETED */}
          <div className="flex flex-col gap-3">
            <span className="text-[10px] font-bold tracking-widest uppercase text-white">
              Product
            </span>
            <span onClick={() => navigate('/features')} className="text-xs text-gray-500 hover:text-white cursor-pointer transition-colors">
              Features
            </span>
            <span onClick={() => navigate('/media')} className="text-xs text-purple-400 font-semibold cursor-pointer transition-colors">
              Media
            </span>
          </div>

          {/* COMPANY LINK MATRICES COMPONENT */}
          <div className="flex flex-col gap-3">
            <span className="text-[10px] font-bold tracking-widest uppercase text-white">
              Company
            </span>
            <span onClick={() => setShowAboutModal(true)} className="text-xs text-gray-500 hover:text-white cursor-pointer transition-colors">
              About Profile
            </span>
            <span onClick={() => setShowPrivacyModal(true)} className="text-xs text-gray-500 hover:text-white cursor-pointer transition-colors">
              Privacy Rules
            </span>
          </div>

          {/* CONTACT VECTOR ACCESS SEGMENT */}
          <div className="flex flex-col gap-3">
            <span className="text-[10px] font-bold tracking-widest uppercase text-white">
              Connect
            </span>
            <span onClick={() => navigate('/contact')} className="text-xs text-gray-500 hover:text-white cursor-pointer transition-colors">
              Contact Center
            </span>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" className="text-xs text-gray-500 hover:text-white transition-colors">
              Twitter Channel
            </a>
          </div>
        </div>

        {/* FOOTER METRICS RULE LINE */}
        <div className="max-w-7xl mx-auto px-6 pt-6 border-t border-gray-900/40 flex flex-col sm:flex-row items-center justify-between gap-4 text-[11px] text-gray-600 font-medium">
          <div>
            © 2026 Atlas AI Operations LLC. All rights reserved.
          </div>
          <div className="flex items-center gap-6">
            <span className="hover:text-gray-400 cursor-pointer transition-colors">System Infrastructure Matrix</span>
            <span className="hover:text-gray-400 cursor-pointer transition-colors">AES-256 Encrypted Security</span>
          </div>
        </div>
      </footer>

      {/* RENDER MODAL LAYERS FOR SYSTEM LEGAL DATA */}
      {showAboutModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-[#070d19] border border-gray-800 max-w-lg w-full rounded-2xl p-6 text-left space-y-4">
            <h3 className="text-lg font-bold text-white">About Atlas AI</h3>
            <p className="text-xs text-gray-400 leading-relaxed">
              Atlas AI is an advanced software engineering system crafted specifically for high-urgency operational service fields. Our proprietary runtime engine minimizes diagnostic latency, accurately maps intake details into standard field management tools, and eliminates workflow dependency on traditional call answering hubs.
            </p>
            <button
              onClick={() => setShowAboutModal(false)}
              className="w-full py-2.5 bg-gray-900 hover:bg-gray-800 text-xs font-bold rounded-xl transition-colors uppercase tracking-wider"
            >
              Close Profile View
            </button>
          </div>
        </div>
      )}

      {showPrivacyModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-[#070d19] border border-gray-800 max-w-lg w-full rounded-2xl p-6 text-left space-y-4">
            <h3 className="text-lg font-bold text-white">Privacy & Security Controls</h3>
            <p className="text-xs text-gray-400 leading-relaxed">
              We employ enterprise isolation blueprints across all conversational processing nodes. Every transcript payload, call log mapping sequence, and data profile link transmitted across local field management endpoints is structurally secured via tokenized end-to-end mechanisms to fully preserve business confidentiality.
            </p>
            <button
              onClick={() => setShowPrivacyModal(false)}
              className="w-full py-2.5 bg-gray-900 hover:bg-gray-800 text-xs font-bold rounded-xl transition-colors uppercase tracking-wider"
            >
              Accept Boundaries
            </button>
          </div>
        </div>
      )}

    </div>
  );
}